<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/packages">{{$t('packaging')}}</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link v-if="header.Status=='Draft'" :to="{ name: 'packaging_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button v-if="header.Status=='Draft'" type="button" class="btn btn-outline-primary btn-sm no-bor" @click="approveClick"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
            <router-link v-if="header.Status=='Posted' && isStockIn" :to="{ name: 'packaging_stock', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-car"></i> {{$t('stock_in')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="printClick"><i class="fa fa-print"></i> {{ $t('print') }}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <h3 class="text-center font-m">{{$t('packaging')}}</h3>
                    <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table-print">
                                <tbody>
                                <tr>
                                    <td style="width: 100px; vertical-align: top;">{{$t('remark')}}</td>
                                    <td style="vertical-align: top;">:</td>
                                    <td>{{header.Description}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="table-print" align="right">
                                <tbody>
                                <tr>
                                    <td>{{$t('code')}}</td>
                                    <td>:</td>
                                    <td>{{header.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{header.Date}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="blue text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th class="blue">{{$t('item_name')}}</th>
                                        <th class="blue text-center" style="width: 120px;">{{$t('qty_base')}}</th>
                                        <th class="blue text-center" style="width: 120px;">{{$t('qty_lost')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('uom_base')}}</th>
                                        <th class="blue text-center" style="width: 120px;">{{$t('qty_packaging')}}</th>
                                        <th class="blue" style="width: 120px;">{{$t('uom_packaging')}}</th>
                                        <th class="blue text-center" style="width: 120px;">{{$t('stock_in')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td class="text-center">{{ret.Quantity}}</td>
                                        <td class="text-center">{{ret.LostQuantity}}</td>
                                        <td>{{ret.UomName}}</td>
                                        <td class="text-center">{{ret.ToQuantity}}</td>
                                        <td>{{ret.ToUomName}}</td>
                                        <td class="text-center" :class="{'bg-danger':isStockIn}">{{ret.TransferQuantity}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            title: this.$t('packaging_preview'),
            header: {},
            lines: [],
            isStockIn: false
        }
    },
    created(){
        let id = this.$route.params.id;
        if(id !== undefined && id !== null && id !== ''){
            this.findById(id);
        }
    },
    methods: {
        approveClick(){
            let loading = this.$loading.show();
            this.$api().post('package/approve', { Id: this.$route.params.id }).then(res => {
                if(this.$isValid(res)){
                    this.$router.push('/packages');
                }
            }).finally(function() { loading.hide(); });
        },
        findById(id){
            let loading = this.$loading.show();
            this.$api().post('package/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    let data = res.data.Json;
                    this.header = data.Header;
                    this.title = '['+this.header.Num+']';
                    this.header.Date = this.$format(this.header.Date, 'YYYY-MM-DD');
                    this.lines = data.Lines;
                    this.calculate();
                }
            }).finally(function() { loading.hide(); });
        },
        calculate(){
            var totalQty = 0;
            var totalTransfer = 0;
            this.lines.forEach(element => {
                totalQty += Number(element.ToQuantity);
                totalTransfer += Number(element.TransferQuantity);
            });
            if(totalTransfer == 0 || totalTransfer < totalQty){
                this.isStockIn = true;
            }
        },
        printClick(){
            window.open('/print/package/' + this.$route.params.id, '_blank');
        }
    }
}
</script>